import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { PureComponent } from 'react';
import { withQueues } from '../../hocs';
import styles from './queueSelect.module.scss';
class QueueSelectImpl extends PureComponent {
    componentDidMount() {
        this.props.queues.getItems();
    }
    render() {
        const { className, queues, onSelect, selectedQueue } = this.props;
        const { items, searchTermChange, getItemsAsyncStatus, searchTerm, hasNextPage, hasPreviousPage, nextPage, previousPage, } = queues;
        const rootClass = classnames(styles.root, className);
        return (_jsx(Select, { className: rootClass, placeholder: "Select a queue", items: items, selectedItems: selectedQueue ? [selectedQueue] : [], onSearch: searchTermChange, onSelect: onSelect, loading: getItemsAsyncStatus === 'loading', emptyMessage: searchTerm ? 'No queues found' : 'No queues available', pagination: {
                nextEnable: hasNextPage,
                previousEnable: hasPreviousPage,
                onNext: nextPage,
                onPrevious: previousPage,
            }, searchable: true }));
    }
}
export const QueueSelect = withQueues(QueueSelectImpl, { pageSize: 25 });
